'use client';

import type { ReactNode } from 'react';
import { BaseModal } from './BaseModal';
import type { ModalZIndex } from './BaseModal';

type DeleteConfirmModalProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  isPending: boolean;
  zIndex?: ModalZIndex;
  /** 딤 처리(opacity)된 카드 안에서 열 때 body로 탈출시킨다. BaseModal의 `portal`과 동일. */
  portal?: boolean;
  footerStart?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DeleteConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  isPending,
  zIndex = 'base',
  portal = false,
  footerStart,
  onConfirm,
  onCancel,
}: DeleteConfirmModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onCancel}
      variant="bottomSheet"
      size="sm"
      zIndex={zIndex}
      portal={portal}
      className="!rounded-2xl !p-6 !pb-6"
    >
      <h3 className="mb-2 text-base font-semibold">{title}</h3>
      <div className="text-sm text-[var(--color-fg-muted)]">{message}</div>
      <div className="modal-action mt-5 flex items-center justify-between gap-2">
        <div className="min-w-0">{footerStart}</div>
        <div className="flex shrink-0 items-center gap-2">
          <button type="button" className="btn btn-ghost btn-sm" onClick={onCancel} disabled={isPending}>
            {cancelLabel}
          </button>
          <button type="button" className="btn btn-error btn-sm" onClick={onConfirm} disabled={isPending}>
            {isPending ? '...' : confirmLabel}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
